import {throttle} from './Util.js';

$('.js-mobile-menu').each(function () {
    const $menu = $(this);
    const $toggler = $('.js-mobile-menu-toggler', this);
    let opening = false;
    let opened = false;
    let scrollTop = 0;

    $toggler.on('click', function () {
        $('.js-close-search').trigger('click');
        opening = $('._mobile-menu--opening').length;
        opened = $('._mobile-menu--opened').length;
        if (!opening) {
            opening = true;
            $menu.addClass('_burger-clicked');

            if (opened) {
                $('.js-mobile-menu-toggler-sm').removeClass('active');
                App.H.addClass('_mobile-menu--closing').removeClass('_mobile-menu--opened');
                $('.mobile-menu-bottom-js').show();
                window.scrollTo(0, scrollTop);
                $menu.animate({'scrollTop': 0}, 10);
                setTimeout(() => {
                    $('.js-mobile-menu-content-head').show();
                    if (!App.H.hasClass('_mobile-submenu')) {
                        App.H.removeClass('_mobile-menu-sublist--opened');
                        $('.js-mobile-menu-sublist._active', $menu).removeClass('_active');
                        $('.js-mobile-user-sublist._active', $menu).removeClass('_active');
                    } else {
                        $('.js-mobile-menu-content-head').hide();
                        App.H.addClass('_mobile-menu-sublist--opened');
                        $('.js-mobile-menu-sublist', $menu).addClass('_active');
                        $('.js-mobile-user-sublist', $menu).addClass('_active');
                    }
                    App.H.removeClass('_mobile-menu--closing');
                    opening = false;
                    opened = !opened;
                }, 300);
            } else {
                $('.js-mobile-menu-toggler-sm').addClass('active');
                scrollTop = window.pageYOffset;
                App.H.addClass('_mobile-menu--opening');
                $('.mobile-menu-bottom-js').hide();
                setTimeout(() => {
                    App.H.addClass('_mobile-menu--opened').removeClass('_mobile-menu--opening');
                    window.scrollTo(0, 0);
                    opening = false;
                    opened = !opened;
                }, 300);
                if ($('.js-dropdown-modal').hasClass('_opened')) {
                    $('.js-dropdown-modal').removeClass('_opened');
                    $('.js-dropdown-modal-open').removeClass('dropdown-modal--opened');
                }
            }
        }
    });

    const $menulist = $('.js-mobile-menu-list');
    const $contentHead = $('.js-mobile-menu-content-head');
    let sublistopening = false;
    let menulistScrollTop = 0;

    $menu.on('click', '.js-mobile-menu-button', function (e) {
        const $parent = $(this).parents('.js-mobile-menu-list');
        const $listItem = $(this).parents('.js-mobile-menu-item');
        let $sublist = $(this).siblings('.js-mobile-menu-sublist');
        const $sublistUser = $menulist.find('.js-mobile-user-sublist');

        let sublistName = $(this).attr('data-sublist');
        if (typeof sublistName !== 'undefined' && sublistName !== false) {
            $sublist = $('#' + sublistName);
        }

        if (
            $parent.find('.js-mobile-menu-item._active').find('.js-mobile-menu-sublist._active') &&
            !$listItem.hasClass('_active')
        ) {
            $parent.find('.js-mobile-menu-item._active').find('.js-mobile-menu-sublist._active').removeClass('_active');
            $parent.find('.js-mobile-menu-item._active').removeClass('_active');
        }

        let isOpened = $sublist.hasClass('_active');
        let isMoreOpened = $('.js-mobile-menu-sublist._active').length;

        if (!sublistopening && !$(e.target).is('a') && !isOpened) {
            sublistopening = true;
            $sublist.addClass('_active');
            $listItem.addClass('_active');
            menulistScrollTop = $menu.scrollTop();
            $contentHead.hide();
            App.H.addClass('_mobile-menu-sublist--opened')
            sublistopening = false;
            if ($('.js-location-change').hasClass('_active')) {
                let finishPositionWrapper;
                let $moreContainer = $('.js-location-more');
                finishPositionWrapper = $moreContainer.offset().top + $moreContainer.innerHeight() - document.documentElement.clientHeight * (App.mobile ? 2 : 1.5);

                locationLoad($moreContainer, finishPositionWrapper);
            }

        } else if (isOpened) {
            $sublist.removeClass('_active');
            $listItem.removeClass('_active');
            $sublistUser.removeClass('_active');
            if (!isMoreOpened) {
                App.H.addClass('_mobile-menu-sublist--closing').removeClass('_mobile-menu-sublist--opened');
            }
            $contentHead.show();
            sublistopening = false;
            $menu.find('.js-header-world-links').hide();
        }
    });

    $menu.one('click', '.js-mobile-menu-button', function () {
        $(this).parent().find('[data-flag]').each(function () {
            $(this).css('background-image', 'url(' + $(this).data('flag') + ')');
        });
    });

    $menu.on('click', '.js-mobile-menu-back', function () {
        const $sublist = $menulist.find('.js-mobile-menu-sublist._active');
        const $sublistUser = $menulist.find('.js-mobile-user-sublist');

        if (!sublistopening) {
            sublistopening = true;

            $sublist.removeClass('_active');
            $sublistUser.removeClass('_active');
            App.H.addClass('_mobile-menu-sublist--closing').removeClass('_mobile-menu-sublist--opened');

            $contentHead.show();
            // window.scrollTo(0,menulistScrollTop);
            $menu.animate({'scrollTop': menulistScrollTop}, 100);
            setTimeout(() => {
                App.H.removeClass('_mobile-menu-sublist--closing');
                sublistopening = false;
                $menu.find('.js-header-world-links').hide();
            }, 300);
        }
    });

    $menu.on('click', '.js-header-world-country', function (e) {
        if (!$(e.target).closest('.js-header-world-links').length) {
            $(this).siblings().find('.js-header-world-links').hide();
            $(this).find('.js-header-world-links')[App.W.width() < 768 ? 'toggle' : 'show']();
        }
    });

    $menu.on('click', '.js-mobile-user-button', function () {
        const $sublist = $('.js-mobile-user-sublist');

        if (!sublistopening) {
            sublistopening = true;

            $sublist.addClass('_active');
            menulistScrollTop = window.pageYOffset;
            App.H.addClass('_mobile-menu-sublist--opening');
            setTimeout(() => {
                $contentHead.hide();
                App.H.addClass('_mobile-menu-sublist--opened').removeClass('_mobile-menu-sublist--opening');
                window.scrollTo(0, 0);
                sublistopening = false;
            }, 300);
        }
    });

    $menu.on('click', '.js-profile-dropdown-trigger', function () {
        $toggler.trigger('click');
        setTimeout(function () {
            $('.js-profile-dropdown').addClass('dropdown-modal--opened').siblings('.js-dropdown-modal').addClass('_opened');
        }, 200);
    });

    function locationLoad($moreContainer, finishPositionWrapper) {
        let prevScroll = 0;
        $('.js-mobile-menu').on('scroll', throttle(function () {
            let currScrollTop = $menu.scrollTop();

            if (currScrollTop > finishPositionWrapper && currScrollTop > prevScroll &&
                !$moreContainer.hasClass('_loading') && !$moreContainer.hasClass('_no-more-load')) {
                $moreContainer.addClass('_loading');

                let currPage = parseInt($('.js-location-page').val());
                let pageParamName = $('.js-location-page').attr('name');
                let loadData = `${pageParamName}=${currPage}`;

                $.ajax({
                    url: $moreContainer.data('url'),
                    method: $moreContainer.data('type'),
                    data: loadData,
                    success: (response) => {
                        let $response = $(response.results);

                        $moreContainer.append($response.html());

                        if ($response.hasClass('_no-more-load')) {
                            $moreContainer.addClass('_no-more-load');
                        }
                        setTimeout(function () {
                            finishPositionWrapper = $moreContainer.offset().top + $moreContainer.innerHeight() - document.documentElement.clientHeight * 1.5;
                            $('.js-location-page').val(currPage + 1);
                            $moreContainer.removeClass('_loading');
                            prevScroll = currScrollTop;
                        }, 300);
                    },
                    error: () => {
                        console.log('Ошибка получения данных фильтра');
                        moreContainer.removeClass('_loading');
                    }
                });
            }
        }, 200));
    }
});

